import {paragraphCarrousel} from "./src/ParagraphCarrousel";
import {paragraphCocktail} from "./src/ParagraphCocktail";
import {paragraphMoreInfos} from "./src/ParagraphMoreInfos";
import {paragraphProducts} from "./src/ParagraphProducts";

(function (Drupal) { // closure
    'use strict';
    Drupal.behaviors.paragraphCarrousel = paragraphCarrousel;
    Drupal.behaviors.paragraphCocktail = paragraphCocktail;
    Drupal.behaviors.paragraphMoreInfos = paragraphMoreInfos;
    Drupal.behaviors.paragraphProducts = paragraphProducts;
}(Drupal));
